import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "confined3": "companies-frontend-b21b3468-confined3-WXUgJq",
  "xwideOffset9": "companies-frontend-b21b3468-xwideOffset9-WXUgJq",
  "confined2": "companies-frontend-b21b3468-confined2-WXUgJq",
  "tinyOffset10": "companies-frontend-b21b3468-tinyOffset10-WXUgJq",
  "confined4": "companies-frontend-b21b3468-confined4-WXUgJq",
  "wideOffset8": "companies-frontend-b21b3468-wideOffset8-WXUgJq",
  "tiny11": "companies-frontend-b21b3468-tiny11-WXUgJq",
  "xwideOffset6": "companies-frontend-b21b3468-xwideOffset6-WXUgJq",
  "tiny12": "companies-frontend-b21b3468-tiny12-WXUgJq",
  "confined11": "companies-frontend-b21b3468-confined11-WXUgJq",
  "xwideOffset0": "companies-frontend-b21b3468-xwideOffset0-WXUgJq",
  "row": "companies-frontend-b21b3468-row-WXUgJq",
  "xwide5": "companies-frontend-b21b3468-xwide5-WXUgJq",
  "wideGridContainer": "companies-frontend-b21b3468-wideGridContainer-WXUgJq",
  "default5": "companies-frontend-b21b3468-default5-WXUgJq",
  "confined9": "companies-frontend-b21b3468-confined9-WXUgJq",
  "wideOffset5": "companies-frontend-b21b3468-wideOffset5-WXUgJq",
  "tiny0": "companies-frontend-b21b3468-tiny0-WXUgJq",
  "wide3": "companies-frontend-b21b3468-wide3-WXUgJq",
  "defaultOffset3": "companies-frontend-b21b3468-defaultOffset3-WXUgJq",
  "default12": "companies-frontend-b21b3468-default12-WXUgJq",
  "gridContainer": "companies-frontend-b21b3468-gridContainer-WXUgJq",
  "confinedOffset10": "companies-frontend-b21b3468-confinedOffset10-WXUgJq",
  "wideOffset6": "companies-frontend-b21b3468-wideOffset6-WXUgJq",
  "xwideOffset8": "companies-frontend-b21b3468-xwideOffset8-WXUgJq",
  "wide0": "companies-frontend-b21b3468-wide0-WXUgJq",
  "xwideOffset10": "companies-frontend-b21b3468-xwideOffset10-WXUgJq",
  "tiny2": "companies-frontend-b21b3468-tiny2-WXUgJq",
  "default7": "companies-frontend-b21b3468-default7-WXUgJq",
  "wideOffset7": "companies-frontend-b21b3468-wideOffset7-WXUgJq",
  "tinyOffset3": "companies-frontend-b21b3468-tinyOffset3-WXUgJq",
  "confined12": "companies-frontend-b21b3468-confined12-WXUgJq",
  "tinyOffset0": "companies-frontend-b21b3468-tinyOffset0-WXUgJq",
  "confinedOffset8": "companies-frontend-b21b3468-confinedOffset8-WXUgJq",
  "default0": "companies-frontend-b21b3468-default0-WXUgJq",
  "defaultOffset1": "companies-frontend-b21b3468-defaultOffset1-WXUgJq",
  "tiny6": "companies-frontend-b21b3468-tiny6-WXUgJq",
  "grid": "companies-frontend-b21b3468-grid-WXUgJq",
  "xwide3": "companies-frontend-b21b3468-xwide3-WXUgJq",
  "wideOffset0": "companies-frontend-b21b3468-wideOffset0-WXUgJq",
  "standardGridContainer": "companies-frontend-b21b3468-standardGridContainer-WXUgJq",
  "defaultOffset8": "companies-frontend-b21b3468-defaultOffset8-WXUgJq",
  "confinedOffset6": "companies-frontend-b21b3468-confinedOffset6-WXUgJq",
  "default3": "companies-frontend-b21b3468-default3-WXUgJq",
  "xwide7": "companies-frontend-b21b3468-xwide7-WXUgJq",
  "defaultOffset6": "companies-frontend-b21b3468-defaultOffset6-WXUgJq",
  "tiny9": "companies-frontend-b21b3468-tiny9-WXUgJq",
  "wide8": "companies-frontend-b21b3468-wide8-WXUgJq",
  "wide10": "companies-frontend-b21b3468-wide10-WXUgJq",
  "tiny5": "companies-frontend-b21b3468-tiny5-WXUgJq",
  "xwide12": "companies-frontend-b21b3468-xwide12-WXUgJq",
  "xwideOffset11": "companies-frontend-b21b3468-xwideOffset11-WXUgJq",
  "confinedOffset11": "companies-frontend-b21b3468-confinedOffset11-WXUgJq",
  "wide1": "companies-frontend-b21b3468-wide1-WXUgJq",
  "wideOffset11": "companies-frontend-b21b3468-wideOffset11-WXUgJq",
  "xwideOffset5": "companies-frontend-b21b3468-xwideOffset5-WXUgJq",
  "confinedOffset5": "companies-frontend-b21b3468-confinedOffset5-WXUgJq",
  "xwide6": "companies-frontend-b21b3468-xwide6-WXUgJq",
  "xwide11": "companies-frontend-b21b3468-xwide11-WXUgJq",
  "xwide8": "companies-frontend-b21b3468-xwide8-WXUgJq",
  "wideOffset4": "companies-frontend-b21b3468-wideOffset4-WXUgJq",
  "wide11": "companies-frontend-b21b3468-wide11-WXUgJq",
  "xwide4": "companies-frontend-b21b3468-xwide4-WXUgJq",
  "default11": "companies-frontend-b21b3468-default11-WXUgJq",
  "confinedOffset4": "companies-frontend-b21b3468-confinedOffset4-WXUgJq",
  "default8": "companies-frontend-b21b3468-default8-WXUgJq",
  "xwide2": "companies-frontend-b21b3468-xwide2-WXUgJq",
  "wide4": "companies-frontend-b21b3468-wide4-WXUgJq",
  "wideOffset10": "companies-frontend-b21b3468-wideOffset10-WXUgJq",
  "tiny8": "companies-frontend-b21b3468-tiny8-WXUgJq",
  "defaultOffset7": "companies-frontend-b21b3468-defaultOffset7-WXUgJq",
  "confined8": "companies-frontend-b21b3468-confined8-WXUgJq",
  "tinyOffset5": "companies-frontend-b21b3468-tinyOffset5-WXUgJq",
  "wideOffset1": "companies-frontend-b21b3468-wideOffset1-WXUgJq",
  "tiny4": "companies-frontend-b21b3468-tiny4-WXUgJq",
  "wideOffset9": "companies-frontend-b21b3468-wideOffset9-WXUgJq",
  "defaultOffset4": "companies-frontend-b21b3468-defaultOffset4-WXUgJq",
  "tinyOffset7": "companies-frontend-b21b3468-tinyOffset7-WXUgJq",
  "confinedOffset1": "companies-frontend-b21b3468-confinedOffset1-WXUgJq",
  "defaultOffset10": "companies-frontend-b21b3468-defaultOffset10-WXUgJq",
  "wide2": "companies-frontend-b21b3468-wide2-WXUgJq",
  "xwideOffset2": "companies-frontend-b21b3468-xwideOffset2-WXUgJq",
  "xwide0": "companies-frontend-b21b3468-xwide0-WXUgJq",
  "confined1": "companies-frontend-b21b3468-confined1-WXUgJq",
  "wideOffset3": "companies-frontend-b21b3468-wideOffset3-WXUgJq",
  "tiny1": "companies-frontend-b21b3468-tiny1-WXUgJq",
  "wide9": "companies-frontend-b21b3468-wide9-WXUgJq",
  "wide7": "companies-frontend-b21b3468-wide7-WXUgJq",
  "defaultOffset2": "companies-frontend-b21b3468-defaultOffset2-WXUgJq",
  "armstrongGridContainer": "companies-frontend-b21b3468-armstrongGridContainer-WXUgJq",
  "default1": "companies-frontend-b21b3468-default1-WXUgJq",
  "col": "companies-frontend-b21b3468-col-WXUgJq",
  "defaultOffset5": "companies-frontend-b21b3468-defaultOffset5-WXUgJq",
  "defaultOffset11": "companies-frontend-b21b3468-defaultOffset11-WXUgJq",
  "wide12": "companies-frontend-b21b3468-wide12-WXUgJq",
  "xwide9": "companies-frontend-b21b3468-xwide9-WXUgJq",
  "default2": "companies-frontend-b21b3468-default2-WXUgJq",
  "tinyOffset1": "companies-frontend-b21b3468-tinyOffset1-WXUgJq",
  "confined7": "companies-frontend-b21b3468-confined7-WXUgJq",
  "wide5": "companies-frontend-b21b3468-wide5-WXUgJq",
  "xwide10": "companies-frontend-b21b3468-xwide10-WXUgJq",
  "defaultOffset9": "companies-frontend-b21b3468-defaultOffset9-WXUgJq",
  "confinedOffset3": "companies-frontend-b21b3468-confinedOffset3-WXUgJq",
  "xwideOffset3": "companies-frontend-b21b3468-xwideOffset3-WXUgJq",
  "tinyOffset11": "companies-frontend-b21b3468-tinyOffset11-WXUgJq",
  "confined0": "companies-frontend-b21b3468-confined0-WXUgJq",
  "confined10": "companies-frontend-b21b3468-confined10-WXUgJq",
  "confinedOffset2": "companies-frontend-b21b3468-confinedOffset2-WXUgJq",
  "xwideOffset1": "companies-frontend-b21b3468-xwideOffset1-WXUgJq",
  "tiny3": "companies-frontend-b21b3468-tiny3-WXUgJq",
  "confined5": "companies-frontend-b21b3468-confined5-WXUgJq",
  "default9": "companies-frontend-b21b3468-default9-WXUgJq",
  "tinyOffset9": "companies-frontend-b21b3468-tinyOffset9-WXUgJq",
  "wideOffset2": "companies-frontend-b21b3468-wideOffset2-WXUgJq",
  "default10": "companies-frontend-b21b3468-default10-WXUgJq",
  "confined6": "companies-frontend-b21b3468-confined6-WXUgJq",
  "tinyOffset8": "companies-frontend-b21b3468-tinyOffset8-WXUgJq",
  "tiny10": "companies-frontend-b21b3468-tiny10-WXUgJq",
  "tinyOffset2": "companies-frontend-b21b3468-tinyOffset2-WXUgJq",
  "xwide1": "companies-frontend-b21b3468-xwide1-WXUgJq",
  "default6": "companies-frontend-b21b3468-default6-WXUgJq",
  "confinedOffset9": "companies-frontend-b21b3468-confinedOffset9-WXUgJq",
  "xwideOffset7": "companies-frontend-b21b3468-xwideOffset7-WXUgJq",
  "tiny7": "companies-frontend-b21b3468-tiny7-WXUgJq",
  "tinyOffset6": "companies-frontend-b21b3468-tinyOffset6-WXUgJq",
  "confinedOffset7": "companies-frontend-b21b3468-confinedOffset7-WXUgJq",
  "default4": "companies-frontend-b21b3468-default4-WXUgJq",
  "tinyOffset4": "companies-frontend-b21b3468-tinyOffset4-WXUgJq",
  "wide6": "companies-frontend-b21b3468-wide6-WXUgJq",
  "xwideOffset4": "companies-frontend-b21b3468-xwideOffset4-WXUgJq",
  "confinedOffset0": "companies-frontend-b21b3468-confinedOffset0-WXUgJq"
};